import SearchComponent from '../../../../../molecules/search/index.jsx'
import { searchVariantsOptions } from '../../../../../molecules/search/constants.js'
import { Search } from '../../../../../atoms/icons/core'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes'
import PropTypes from 'prop-types'

const ToolbarSearch = ({
  onChangeSearch,
  value,
  defaultDesktopVariantOpen,
  disabled = false
}) => {
  return (
    <SearchComponent.Root
      variant={searchVariantsOptions.DESKTOP}
      customOnChange={onChangeSearch}
      defaultDesktopVariantOpen={defaultDesktopVariantOpen}
      placeholder={'Search'}
      disabled={disabled}
      style={{ maxWidth: '100px' }}
    >
      <SearchComponent.Container>
        <SearchComponent.LeadingIcon
          icon={Search}
          size={iconSizeOptions['ICON-M']}
        />
        <SearchComponent.Input value={value} />
        <SearchComponent.ClearButton />
      </SearchComponent.Container>
      <SearchComponent.CancelButton />
    </SearchComponent.Root>
  )
}

ToolbarSearch.propTypes = {
  onChangeSearch: PropTypes.func,
  value: PropTypes.string,
  defaultDesktopVariantOpen: PropTypes.bool,
  disabled: PropTypes.bool
}

export default ToolbarSearch
